import { render, staticRenderFns } from "./AccessibilityTable.vue?vue&type=template&id=cb6d450a&scoped=true"
import script from "./AccessibilityTable.vue?vue&type=script&lang=js"
export * from "./AccessibilityTable.vue?vue&type=script&lang=js"
import "./AccessibilityTable.vue?vue&type=style&index=0&id=cb6d450a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d450a",
  null
  
)

export default component.exports